import React, {
  useEffect,
  useState,
} from "react";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
} from "react-bootstrap";

import {
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import {
  RiShareForwardLine,
  RiDownloadFill,
} from "react-icons/ri";

import {
  MdOutlineBlock,
  MdOutlineDeleteOutline,
} from "react-icons/md";

import { HiOutlineMail } from "react-icons/hi";

import { FaArrowLeft } from "react-icons/fa";

import { SiTicktick } from "react-icons/si";

import { ImConfused } from "react-icons/im";

function Employeejobproview() {

  const { id } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const [candidate, setCandidate] =
    useState(null);

  /* =========================================
     LOAD CANDIDATE
  ========================================= */

  useEffect(() => {

    console.log(
      "LOCATION STATE :",
      location.state
    );

    console.log(
      "CANDIDATE :",
      location.state?.candidate
    );

    if (
      location.state?.candidate
    ) {

      setCandidate(
        location.state.candidate
      );

    } else {

      setCandidate(null);
    }

  }, [location.state]);

  /* =========================================
     NOT FOUND
  ========================================= */

  if (!candidate) {

    return (

      <div className="text-center mt-5">

        <h4 className="text-danger">

          Candidate Not Found

        </h4>

      </div>
    );
  }

  /* =========================================
     STATUS UPDATE
  ========================================= */

  const updateStatus = (
    status
  ) => {

    setCandidate((prev) => ({

      ...prev,

      status,
    }));

    alert(
      `Candidate ${status}`
    );
  };

  /* =========================================
     DOWNLOAD RESUME
  ========================================= */

  const handleDownload = () => {

    if (!candidate.resume) {

      alert(
        "Resume not uploaded"
      );

      return;
    }

    try {

      const link =
        document.createElement("a");

      link.href =
        candidate.resume;

      link.download =
        `${candidate.firstName || "candidate"}_resume`;

      document.body.appendChild(
        link
      );

      link.click();

      document.body.removeChild(
        link
      );

    } catch (error) {

      console.log(
        "DOWNLOAD ERROR :",
        error
      );

      alert(
        "Unable to download resume"
      );
    }
  };

  /* =========================================
     DELETE
  ========================================= */

  const handleDelete = () => {

    const confirmDelete =
      window.confirm(
        "Delete this candidate?"
      );

    if (!confirmDelete) {

      return;
    }

    alert(
      "Candidate Deleted"
    );

    navigate(-1);
  };

  /* =========================================
     UI
  ========================================= */

  return (

    <Container className="py-4 mt-4 bg-white">

      {/* BACK BUTTON */}

      <Button
        size="sm"
        variant="outline-secondary"
        onClick={() =>
          navigate(-1)
        }
        className="mb-3"
      >

        <FaArrowLeft />
        {" "}
        Back to Candidates

      </Button>

      {/* TITLE */}

      <h2 className="text-center fw-bold my-4">

        Candidate Profile

      </h2>

      {/* ACTION BUTTONS */}

      <div className="d-flex flex-wrap gap-2 justify-content-end mb-4">

        <Button
          size="sm"
          variant="success"
          onClick={() =>
            updateStatus(
              "Shortlisted"
            )
          }
        >

          <SiTicktick />
          {" "}
          Shortlist

        </Button>

        <Button
          size="sm"
          variant="warning"
          onClick={() =>
            updateStatus(
              "Maybe"
            )
          }
        >

          <ImConfused />
          {" "}
          Maybe

        </Button>

        <Button
          size="sm"
          variant="outline-danger"
          onClick={() =>
            updateStatus(
              "Rejected"
            )
          }
        >

          <MdOutlineBlock />
          {" "}
          Reject

        </Button>

        <Button
          size="sm"
          variant="primary"
        >

          <HiOutlineMail />
          {" "}
          Email

        </Button>

        <Button
          size="sm"
          variant="secondary"
        >

          <RiShareForwardLine />
          {" "}
          Forward

        </Button>

        <Button
          size="sm"
          variant="outline-secondary"
          onClick={
            handleDownload
          }
        >

          <RiDownloadFill />
          {" "}
          Download Resume

        </Button>

        <Button
          size="sm"
          variant="outline-danger"
          onClick={
            handleDelete
          }
        >

          <MdOutlineDeleteOutline />
          {" "}
          Delete

        </Button>

      </div>

      {/* PERSONAL INFO */}

      <ProfileCard title="Personal Information">

        <Field
          label="First Name"
          value={
            candidate.firstName
          }
        />

        <Field
          label="Last Name"
          value={
            candidate.lastName
          }
        />

        <Field
          label="Full Name"
          value={
            candidate.fullName
          }
        />

        <Field
          label="Email"
          value={
            candidate.email
          }
        />

        <Field
          label="Phone"
          value={
            candidate.phone
          }
        />

        <Field
          label="Gender"
          value={
            candidate.gender
          }
        />

        <Field
          label="Location"
          value={
            candidate.location
          }
        />

        <Field
          label="Student ID"
          value={
            candidate.studentId
          }
        />

        <Field
          label="Membership ID"
          value={
            candidate.membershipId
          }
        />

        <Field
          label="LinkedIn / Portfolio URL"
          value={
            candidate.linkedIn
          }
        />

      </ProfileCard>

      {/* EDUCATIONAL INFO */}

      <ProfileCard title="Educational Information">

        <Field
          label="Qualification"
          value={
            candidate.qualification
          }
        />

        <Field
          label="Specialization"
          value={
            candidate.specialization
          }
        />

        <Field
          label="University"
          value={
            candidate.university
          }
        />

        <Field
          label="College"
          value={
            candidate.college
          }
        />

      </ProfileCard>

      {/* JOB DETAILS */}

      <ProfileCard title="Job Details">

        <Field
          label="Position Applied For"
          value={
            candidate.positionAppliedFor
          }
        />

        <Field
          label="Preferred Work Mode"
          value={
            candidate.preferredWorkMode
          }
        />

        <Field
          label="Experience"
          value={
            candidate.experience
          }
        />

        <Field
          label="Key Skills"
          value={
            candidate.keySkills
          }
        />

        <Field
          label="Expected Salary"
          value={
            candidate.expectedSalary
          }
        />

        <Field
          label="Status"
          value={
            candidate.status
          }
        />

        <Field
          label="Applied At"
          value={
            candidate.appliedAt
          }
        />

      </ProfileCard>

      {/* EXPERIENCE DETAILS */}

      <ProfileCard title="Experience Details">

        {candidate.experienceDetails &&
        candidate.experienceDetails
          .length > 0 ? (

          candidate.experienceDetails.map(
            (
              exp,
              index
            ) => (

              <Col
                md={12}
                key={index}
                className="border rounded p-3 mb-3"
              >

                <Row>

                  <Field
                    label="Company"
                    value={
                      exp.company
                    }
                  />

                  <Field
                    label="Role"
                    value={
                      exp.role
                    }
                  />

                  <Field
                    label="Joining Date"
                    value={
                      exp.joining
                    }
                  />

                  <Field
                    label="Relieving Date"
                    value={
                      exp.relieving
                    }
                  />

                </Row>

              </Col>
            )
          )

        ) : (

          <Col md={12}>

            <strong>

              Fresher Candidate

            </strong>

          </Col>
        )}

      </ProfileCard>

      {/* WHY HIRE ME */}

      <Card className="mb-3">

        <Card.Header className="bg-primary text-white fw-semibold">

          Why Hire Me

        </Card.Header>

        <Card.Body>

          {candidate.whyHireMe ||
            "N/A"}

        </Card.Body>

      </Card>

      {/* RESUME */}

      <Card className="mb-3">

        <Card.Header className="bg-primary text-white fw-semibold">

          Resume

        </Card.Header>

        <Card.Body>

          {candidate.resume ? (

            <Button
              variant="outline-primary"
              onClick={
                handleDownload
              }
            >

              <RiDownloadFill />
              {" "}
              Download Resume

            </Button>

          ) : (

            <p>
              Resume Not Available
            </p>
          )}

        </Card.Body>

      </Card>

    </Container>
  );
}

/* =========================================
   REUSABLE PROFILE CARD
========================================= */

const ProfileCard = ({
  title,
  children,
}) => (

  <Card className="mb-3">

    <Card.Header className="bg-primary text-white fw-semibold">

      {title}

    </Card.Header>

    <Card.Body>

      <Row>

        {children}

      </Row>

    </Card.Body>

  </Card>
);

/* =========================================
   REUSABLE FIELD
========================================= */

const Field = ({
  label,
  value,
}) => (

  <Col md={6} className="mb-3">

    <strong>
      {label} :
    </strong>
    {" "}
    {value || "N/A"}

  </Col>
);

export default Employeejobproview;